/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useContext } from 'react';
import { MENU_ID_ROADMAPS_VIEW_ALL } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import type { NavSubmenuFooter } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { ViewAllEntityMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/view-all-entity-menu-item/index.tsx';
import { getCollectionsPageUrl } from '@jira/polaris__component-collections/src/getCollectionsPageUrl.tsx';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { MenuSection } from '@atlaskit/side-nav-items/menu-section';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { AnalyticContext } from '../../controllers/analytic-context/index.tsx';

const viewAllRoadmaps = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.footer.view-all-roadmaps',

	defaultMessage: 'View all roadmaps',
	description: 'Message for the view all roadmaps menu item in the roadmaps submenu',
});

export const Footer: NavSubmenuFooter = ({ onClose }) => {
	const { formatMessage } = useIntl();

	const { fireUIAnalyticForFixMenuItem } = useContext(AnalyticContext);

	return (
		<MenuListItem>
			<MenuSection>
				<MenuList>
					<ViewAllEntityMenuItem
						href={getCollectionsPageUrl()}
						menuId={MENU_ID_ROADMAPS_VIEW_ALL}
						onClick={(e) => {
							fireUIAnalyticForFixMenuItem();
							onClose?.(e);
						}}
					>
						{formatMessage(viewAllRoadmaps)}
					</ViewAllEntityMenuItem>
				</MenuList>
			</MenuSection>
		</MenuListItem>
	);
};
